import { render, staticRenderFns } from "./AnswerAdd.vue?vue&type=template&id=0e1c8020&scoped=true&"
import script from "./AnswerAdd.vue?vue&type=script&lang=js&"
export * from "./AnswerAdd.vue?vue&type=script&lang=js&"
import style0 from "./AnswerAdd.vue?vue&type=style&index=0&id=0e1c8020&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1c8020",
  null
  
)

export default component.exports